import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { LimitsPerNbSteps } from '@shared/constants';
import { SvgDirective } from '@shared/directives';
import { StepChallenge } from '@shared/factory';
import { StepChallengeVariant6Config } from '@shared/models';
import {
  AmountPartsPipe,
  AmountPipe,
  ProgressWidthPipe,
  RewardPipe,
  SafePipe,
  StepStatusPipe,
  VariableReplacementPipe,
} from '@shared/pipes';

@Component({
  selector: 'b2c-progress-section',
  templateUrl: './progress-section.component.html',
  styleUrl: './progress-section.component.scss',
  imports: [
    AmountPipe,
    AmountPartsPipe,
    SvgDirective,
    RewardPipe,
    SafePipe,
    StepStatusPipe,
    ProgressWidthPipe,
    VariableReplacementPipe,
  ],
})
export class ProgressSectionComponent extends BaseComponent {
  challenge = input.required<StepChallenge>();
  config = input.required<StepChallengeVariant6Config>();

  public limitsPerNbSteps: LimitsPerNbSteps = {
    oneStep: { start: 0, end: 180 },
    twoStep: { step1: { start: 0, end: 71 }, step2: { start: 86, end: 189 } },
    threeStep: {
      step1: { start: 0, end: 28 },
      step2: { start: 38, end: 103 },
      step3: { start: 113, end: 178 },
    },
  };
}
